import { render, staticRenderFns } from "./CompanyChangeLogsDetailsView.vue?vue&type=template&id=536039d4&scoped=true"
import script from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyChangeLogsDetailsView.vue?vue&type=style&index=0&id=536039d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536039d4",
  null
  
)

export default component.exports